export default __webpack_public_path__ + "static/media/exchange.08a733dd.png";